<template>
    <div class="usuarios-admin">
        <div class="tituloCadastroFormFront">Gestão dos Usuários</div>
        <hr>
        <b-form>
            <input id="user-id" type="hidden" v-model="usuario.id" />

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Nome:" label-for="user-name">
                        <b-form-input id="user-name" type="text"
                            v-model="usuario.nome" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o Nome do Usuário..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="E-mail:" label-for="user-email">
                        <b-form-input id="user-email" type="text"
                            v-model="usuario.email" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o E-mail do Usuário..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-show="mode === 'save'">
                <b-col md="4" sm="12">
                    <b-form-group label="Empresa:" label-for="user-empresa">
                        <b-form-input id="user-empresa" type="text"
                            v-model="usuario.empresa" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe a empresa do Usuário..." />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group label="Cargo:" label-for="user-cargo">
                        <b-form-input id="user-cargo" type="text"
                            v-model="usuario.cargo" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o cargo do Usuário..." />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group label="Telefone ou Celular:" label-for="user-telefone">
                        <b-form-input id="user-telefone" type="text"
                            v-model="usuario.telefone" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o Telefone ou o Celular do Usuário..." />
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row v-show="mode === 'save'">
                <b-col cols="12">
                    <b-form-select v-model="perfilSelecionado" 
                        :options="perfis" class="mt-3 mb-3">
                    </b-form-select>
                </b-col>
            </b-row>

           <!-- <b-form-checkbox id="user-admin" v-show="mode === 'save'"
                v-model="user.admin" class="mt-3 mb-3">
                Administrador?form-check-inline
            </b-form-checkbox> -->
           
            <b-row v-show="mode === 'save'">
                <b-col md="6" sm="12">
                    <b-form-group label="Senha:" label-for="user-password">
                        <b-form-input id="user-password" type="password"
                            v-model="usuario.hionacredita" required
                            placeholder="Informe a Senha do Usuário..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Confirmação de Senha:" 
                        label-for="user-confirm-password">
                        <b-form-input id="user-confirm-password" type="password"
                            v-model="usuario.confirmahionacredita" required
                            placeholder="Confirme a Senha do Usuário..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col xs="12">
                    <b-button variant="primary" v-if="mode === 'save'"
                        @click="save">Salvar</b-button>
                    <b-button variant="danger" v-if="mode === 'remove'"
                        @click="remove">Excluir</b-button>
                    <b-button class="ml-2" @click="reset">Cancelar</b-button>
                </b-col>
            </b-row>

        </b-form>

        <hr>

        <b-table hover striped :items="usuarios" :fields="fields">
            <template v-slot:cell(actions)="data">
                <b-button variant="warning" @click="loadUsuario(data.item)" class="mr-2">
                    <i class="fas fa-pen-alt"></i>
                </b-button>
                <b-button variant="danger" @click="loadUsuario(data.item, 'remove')">
                    <i class="fas fa-trash-alt"></i>
                </b-button>
            </template>
        </b-table>

    </div>
</template>

<script>
import { baseApiUrl, showError } from '../../../global'
import axios from 'axios'

export default {
    name: 'UsuariosAdmin',
    data: function() {
        return {
            mode: 'save',
            usuario: {},
            usuarios: [],
            perfilSelecionado: null,
            fields: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'email', label: 'E-mail', sortable: true },
                { key: 'admin', label: 'Administrador', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
                { key: 'operador', label: 'Operador', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
                { key: 'encarregado', label: 'Encarregado', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
                { key: 'actions', label: 'Ações' }
            ],
            perfis: [
                { value: null, text: 'Selecione o Perfil do Usuário' },
                { value: 'Administrador', text: 'Administrador' },
                { value: 'Encarregado', text: 'Encarregado' },
                { value: 'Operador', text: 'Operador' },
            ]
        }
    },
    methods: {
        loadUsuarios() {
            const url = `${baseApiUrl}/usuarios`
            axios.get(url).then(res => {
                this.usuarios = res.data
            })
        },
        save(evt) {
            evt.preventDefault()

            if(this.usuario.nome === undefined) {
               alert('Por favor insira o Nome do usuário')
               return
            }
            if(this.usuario.email === undefined) {
               alert('Por favor insira o E-mail do usuário')
               return
            }
            if(this.usuario.empresa === undefined) {
               alert('Por favor insira o nome da Empresa deste Usuário!')
               return
            }
            if(this.usuario.cargo === undefined) {
               alert('Por favor insira o Cargo deste Usuário!')
               return
            }
            if(this.usuario.telefone === undefined) {
               alert('Por favor insira o Telefone ou Celular do Usuário!')
               return
            }
            if(this.perfilSelecionado === null) {
               alert('Por favor Selecione um Perfil para este Usuário!')
               return
            }
            if(this.usuario.hionacredita === undefined) {
                alert('Por favor insira uma Senha para este Usuário!')
                return
            }
            if(this.usuario.confirmahionacredita === undefined) {
                alert('Por favor confirme Senha para este Usuário!')
                return
            }
            if(!(this.usuario.hionacredita == this.usuario.confirmahionacredita)) {
                alert('A Senha e a Confirmação da Senha não conferem!')
                return
            }

            if(this.perfilSelecionado == 'Administrador') {
                this.usuario.admin = "true"
                this.usuario.encarregado = "false"
                this.usuario.operador = "false"
            }
            if(this.perfilSelecionado == 'Encarregado') {
                this.usuario.admin = "false"
                this.usuario.encarregado = "true"
                this.usuario.operador = "false"
            }
            if(this.perfilSelecionado == 'Operador') {
                this.usuario.admin = "false"
                this.usuario.encarregado = "false"
                this.usuario.operador = "true"
            }

            const method = this.usuario.id ? 'put' : 'post'
            const id = this.usuario.id ? `/${this.usuario.id}` : ''
            axios[method](`${baseApiUrl}/usuarios${id}`, this.usuario)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
            //alert(JSON.stringify(this.usuario))
            setTimeout(function(){
                this.loadUsuarios()
            }, 5000);
        },
        reset() {
            this.mode = 'save'
            this.usuario = {}
            this.perfilSelecionado = null
            this.loadUsuarios()
        },
        remove() {
            const id = this.usuario.id
            axios.delete(`${baseApiUrl}/usuarios/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
            setTimeout(function(){
                this.loadUsuarios()
            }, 5000);

        },
        loadUsuario(usuario, mode = 'save') {
            this.mode = mode;
            this.usuario = { ...usuario };
        }
    },
    mounted() {
        this.loadUsuarios()
    }
}
</script>

<style>

</style>